import React from 'react';
import CompetitionList from '../components/competitions/CompetitionList';

const Competitions = () => {
  return <CompetitionList />;
};

export default Competitions;